import { httpsCallable } from 'firebase/functions';
import firebaseConfig from '../../config';

const { databaseId } = firebaseConfig;

function EmailsFactory(firebase) {
  const sendReplyNotification = async ({
    parentCommenterUID,
    sessionId,
    emailData
  }) => {
    const sendReplyNotificationCallable = httpsCallable(
      firebase.functions,
      'emails-send-replyNotification'
    );
    return sendReplyNotificationCallable({
      parentCommenterUID,
      sessionId,
      emailData,
      databaseId
    });
  };

  const sendMentionNotifications = async ({
    mentionedUIDs,
    sessionId,
    emailData
  }) => {
    const sendMentionNotificationsCallable = httpsCallable(
      firebase.functions,
      'emails-send-mentionNotifications'
    );
    return sendMentionNotificationsCallable({
      mentionedUIDs,
      sessionId,
      emailData,
      databaseId
    });
  };

  const sendReminder = async ({ users, templateAlias, emailData }) => {
    const sendReminderCallable = httpsCallable(
      firebase.functions,
      'emails-send-reminder'
    );
    return sendReminderCallable({
      users,
      templateAlias,
      emailData,
      databaseId
    });
  };

  const sendNewQuestionReleased = async ({
    users,
    templateAlias,
    emailData
  }) => {
    const sendNewQuestionReleasedCallable = httpsCallable(
      firebase.functions,
      'emails-send-newQuestionReleased'
    );
    return sendNewQuestionReleasedCallable({
      users,
      templateAlias,
      emailData,
      databaseId
    });
  };

  const sendMagicLink = async ({
    email,
    sessionId,
    origin,
    href,
    emailData,
    language
  }) => {
    const sendMagicLinkCallable = httpsCallable(
      firebase.functions,
      'emails-send-magicLink'
    );
    return sendMagicLinkCallable({
      email,
      sessionId,
      origin,
      href,
      emailData,
      // The caller's active UI language — a locale SELECTOR, not content
      // (§7.4): the recipient has no stored preference before first login,
      // but is visibly reading the login screen in some language. The
      // function validates it against the instance's enabled set.
      language,
      databaseId
    });
  };

  return {
    sendReplyNotification,
    sendMentionNotifications,
    sendReminder,
    sendMagicLink,
    sendNewQuestionReleased
  };
}

export default EmailsFactory;
